/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../src/app/app.module';
import * as import2 from '@angular/common';
import * as import3 from '@angular/router';
import * as import4 from '@angular/platform-browser';
import * as import5 from '@angular/http';
import * as import6 from '@angular/forms';
import * as import7 from '../../../src/app/sharedcore.module';
import * as import8 from 'ngx-infinite-scroll';
import * as import9 from 'ngx-bootstrap/dropdown/bs-dropdown.module';
import * as import10 from '@ngu/carousel/src/ngu-carousel.module';
import * as import11 from 'ngx-bootstrap/buttons/buttons.module';
import * as import12 from 'ngx-bootstrap/modal/modal.module';
import * as import13 from 'ngx-bootstrap/tooltip/tooltip.module';
import * as import14 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover.module';
import * as import15 from 'ngx-bootstrap/tabs/tabs.module';
import * as import16 from 'ngx-bootstrap/collapse/collapse.module';
import * as import17 from 'ngx-bootstrap/accordion/accordion.module';
import * as import18 from 'ngx-bootstrap/typeahead/typeahead.module';
import * as import19 from 'ngx-swiper-wrapper/dist/lib/swiper.module';
import * as import20 from '@angular/flex-layout/media-query/_module';
import * as import21 from '@angular/flex-layout/flexbox/_module';
import * as import22 from '../../../src/app/shared.module';
import * as import23 from 'apollo-angular/build/src/ApolloModule';
import * as import24 from '@ngu/carousel/src/ngu-carousel.service';
import * as import25 from '@angular/flex-layout/media-query/breakpoints/break-point-registry';
import * as import26 from '@angular/flex-layout/media-query/match-media';
import * as import27 from 'ngx-bootstrap/positioning/positioning.service';
import * as import28 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as import29 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as import30 from 'ngx-bootstrap/modal/bs-modal.service';
import * as import31 from 'ngx-bootstrap/tooltip/tooltip.config';
import * as import32 from 'positioning/dist/positioning';
import * as import33 from 'ngx-bootstrap/tabs/tabset.config';
import * as import34 from 'ngx-bootstrap/accordion/accordion.config';
import * as import35 from '../../../src/app/shared/services/user.service';
import * as import36 from '../../../src/app/shared/services/window-ref.service';
import * as import37 from '../../../src/app/shared/services/auth.service';
import * as import38 from '../../../src/app/shared/auth.guard';
import * as import39 from '../../../src/app/shared/services/artist-search.service';
import * as import40 from '../../node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory';
import * as import41 from '../../node_modules/ngx-bootstrap/modal/modal-backdrop.component.ngfactory';
import * as import42 from '../../node_modules/ngx-bootstrap/modal/modal-container.component.ngfactory';
import * as import43 from '../../node_modules/ngx-bootstrap/tooltip/tooltip-container.component.ngfactory';
import * as import44 from '../../node_modules/angular-confirmation-popover/dist/esm/src/confirmation-popover-window.component.ngfactory';
import * as import45 from '../../node_modules/ngx-bootstrap/typeahead/typeahead-container.component.ngfactory';
import * as import46 from './app.component.ngfactory';
import * as import47 from '@angular/flex-layout/media-query/breakpoints/break-points-provider';
import * as import48 from '@angular/flex-layout/media-query/media-monitor-provider';
import * as import49 from '@angular/flex-layout/media-query/media-monitor';
import * as import50 from '@angular/flex-layout/media-query/observable-media-provider';
import * as import51 from '@angular/flex-layout/media-query/observable-media';
import * as import52 from 'apollo-angular/build/src/Apollo';
import * as import53 from '../../../src/app/graphql.client';
import * as import54 from '@angular/flex-layout/media-query/breakpoints/break-points-token';
import * as import55 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as import56 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover-options.provider';
import * as import57 from 'apollo-angular/build/src/tokens';
class AppModuleInjector extends import0.ɵNgModuleInjector<import1.AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ErrorHandler_1:any;
  _NgProbeToken_2:any[];
  _ɵg_3:import3.ɵg;
  _APP_INITIALIZER_4:any[];
  _ApplicationInitStatus_5:import0.ApplicationInitStatus;
  _ɵf_6:import0.ɵf;
  _ApplicationRef_7:any;
  _ApplicationModule_8:import0.ApplicationModule;
  _BrowserModule_9:import4.BrowserModule;
  _HttpModule_10:import5.HttpModule;
  _ɵba_11:import6.ɵba;
  _ReactiveFormsModule_12:import6.ReactiveFormsModule;
  _FormsModule_13:import6.FormsModule;
  _SharedcoreModule_14:import7.SharedcoreModule;
  _InfiniteScrollModule_15:import8.InfiniteScrollModule;
  _BsDropdownModule_16:import9.BsDropdownModule;
  _NguCarouselModule_17:import10.NguCarouselModule;
  _ButtonsModule_18:import11.ButtonsModule;
  _ModalModule_19:import12.ModalModule;
  _TooltipModule_20:import13.TooltipModule;
  _ConfirmationPopoverModule_21:import14.ConfirmationPopoverModule;
  _TabsModule_22:import15.TabsModule;
  _CollapseModule_23:import16.CollapseModule;
  _AccordionModule_24:import17.AccordionModule;
  _TypeaheadModule_25:import18.TypeaheadModule;
  _SwiperModule_26:import19.SwiperModule;
  _MediaQueriesModule_27:import20.MediaQueriesModule;
  _FlexLayoutModule_28:import21.FlexLayoutModule;
  _SharedModule_29:import22.SharedModule;
  _ɵa_30:any;
  _UrlSerializer_31:import3.DefaultUrlSerializer;
  _RouterOutletMap_32:import3.RouterOutletMap;
  _ROUTER_CONFIGURATION_33:any;
  _LocationStrategy_34:any;
  _Location_35:import2.Location;
  _Compiler_36:import0.Compiler;
  _NgModuleFactoryLoader_37:import0.SystemJsNgModuleLoader;
  _ROUTES_38:any[];
  _Router_39:any;
  _RouterModule_40:import3.RouterModule;
  _ApolloModule_41:import23.ApolloModule;
  _AppModule_42:import1.AppModule;
  __LOCALE_ID_43:any;
  __NgLocalization_44:import2.NgLocaleLocalization;
  __APP_ID_45:any;
  __IterableDiffers_46:any;
  __KeyValueDiffers_47:any;
  __DomSanitizer_48:import4.ɵe;
  __Sanitizer_49:any;
  __HAMMER_GESTURE_CONFIG_50:import4.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_51:any[];
  __EventManager_52:import4.EventManager;
  __ɵDomSharedStylesHost_53:import4.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_54:import4.ɵDomRendererFactory2;
  __RendererFactory2_55:any;
  __ɵSharedStylesHost_56:any;
  __Testability_57:import0.Testability;
  __Meta_58:import4.Meta;
  __Title_59:import4.Title;
  __BrowserXhr_60:import5.BrowserXhr;
  __ResponseOptions_61:import5.BaseResponseOptions;
  __XSRFStrategy_62:any;
  __XHRBackend_63:import5.XHRBackend;
  __RequestOptions_64:import5.BaseRequestOptions;
  __Http_65:any;
  __FormBuilder_66:import6.FormBuilder;
  __ɵi_67:import6.ɵi;
  __PositionResolver_68:import8.PositionResolver;
  __ScrollRegister_69:import8.ScrollRegister;
  __NguCarouselService_70:import24.NguCarouselService;
  __BREAKPOINTS_71:any;
  __BreakPointRegistry_72:import25.BreakPointRegistry;
  __MatchMedia_73:import26.MatchMedia;
  __MediaMonitor_74:any;
  __ObservableMedia_75:any;
  __PositioningService_76:import27.PositioningService;
  __ComponentLoaderFactory_77:import28.ComponentLoaderFactory;
  __BsDropdownState_78:import29.BsDropdownState;
  _BsDropdownConfig_79:any;
  __BsModalService_80:import30.BsModalService;
  __TooltipConfig_81:import31.TooltipConfig;
  _USER_OPTIONS_82:any;
  __ConfirmationPopoverOptions_83:any;
  __Positioning_84:import32.Positioning;
  __TabsetConfig_85:import33.TabsetConfig;
  __AccordionConfig_86:import34.AccordionConfig;
  __ActivatedRoute_87:any;
  __NoPreloading_88:import3.NoPreloading;
  __PreloadingStrategy_89:any;
  __RouterPreloader_90:import3.RouterPreloader;
  __PreloadAllModules_91:import3.PreloadAllModules;
  __ROUTER_INITIALIZER_92:any;
  __APP_BOOTSTRAP_LISTENER_93:any[];
  _CLIENT_MAP_WRAPPER_94:any;
  __CLIENT_MAP_95:any;
  __Apollo_96:any;
  __UserService_97:import35.UserService;
  __WindowRefService_98:import36.WindowRefService;
  __AuthService_99:import37.AuthService;
  __AuthGuard_100:import38.AuthGuard;
  __ArtistSearchService_101:import39.ArtistSearchService;
  constructor(parent:import0.Injector) {
    super(parent,[
      import40.BsDropdownContainerComponentNgFactory,
      import41.ModalBackdropComponentNgFactory,
      import42.ModalContainerComponentNgFactory,
      import43.TooltipContainerComponentNgFactory,
      import44.ConfirmationPopoverWindowComponentNgFactory,
      import45.TypeaheadContainerComponentNgFactory,
      import46.AppComponentNgFactory
    ]
    ,[import46.AppComponentNgFactory]);
  }
  get _LOCALE_ID_43():any {
    if ((this.__LOCALE_ID_43 == null)) { (this.__LOCALE_ID_43 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_43;
  }
  get _NgLocalization_44():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_44 == null)) { (this.__NgLocalization_44 = new import2.NgLocaleLocalization(this._LOCALE_ID_43)); }
    return this.__NgLocalization_44;
  }
  get _APP_ID_45():any {
    if ((this.__APP_ID_45 == null)) { (this.__APP_ID_45 = import0.ɵg()); }
    return this.__APP_ID_45;
  }
  get _IterableDiffers_46():any {
    if ((this.__IterableDiffers_46 == null)) { (this.__IterableDiffers_46 = import0.ɵl()); }
    return this.__IterableDiffers_46;
  }
  get _KeyValueDiffers_47():any {
    if ((this.__KeyValueDiffers_47 == null)) { (this.__KeyValueDiffers_47 = import0.ɵm()); }
    return this.__KeyValueDiffers_47;
  }
  get _DomSanitizer_48():import4.ɵe {
    if ((this.__DomSanitizer_48 == null)) { (this.__DomSanitizer_48 = new import4.ɵe(this.parent.get(import4.DOCUMENT))); }
    return this.__DomSanitizer_48;
  }
  get _Sanitizer_49():any {
    if ((this.__Sanitizer_49 == null)) { (this.__Sanitizer_49 = this._DomSanitizer_48); }
    return this.__Sanitizer_49;
  }
  get _HAMMER_GESTURE_CONFIG_50():import4.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_50 == null)) { (this.__HAMMER_GESTURE_CONFIG_50 = new import4.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_50;
  }
  get _EVENT_MANAGER_PLUGINS_51():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_51 == null)) { (this.__EVENT_MANAGER_PLUGINS_51 = [
      new import4.ɵDomEventsPlugin(this.parent.get(import4.DOCUMENT)),
      new import4.ɵKeyEventsPlugin(this.parent.get(import4.DOCUMENT)),
      new import4.ɵHammerGesturesPlugin(this.parent.get(import4.DOCUMENT),this._HAMMER_GESTURE_CONFIG_50)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_51;
  }
  get _EventManager_52():import4.EventManager {
    if ((this.__EventManager_52 == null)) { (this.__EventManager_52 = new import4.EventManager(this._EVENT_MANAGER_PLUGINS_51,this.parent.get(import0.NgZone))); }
    return this.__EventManager_52;
  }
  get _ɵDomSharedStylesHost_53():import4.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_53 == null)) { (this.__ɵDomSharedStylesHost_53 = new import4.ɵDomSharedStylesHost(this.parent.get(import4.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_53;
  }
  get _ɵDomRendererFactory2_54():import4.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_54 == null)) { (this.__ɵDomRendererFactory2_54 = new import4.ɵDomRendererFactory2(this._EventManager_52,this._ɵDomSharedStylesHost_53)); }
    return this.__ɵDomRendererFactory2_54;
  }
  get _RendererFactory2_55():any {
    if ((this.__RendererFactory2_55 == null)) { (this.__RendererFactory2_55 = this._ɵDomRendererFactory2_54); }
    return this.__RendererFactory2_55;
  }
  get _ɵSharedStylesHost_56():any {
    if ((this.__ɵSharedStylesHost_56 == null)) { (this.__ɵSharedStylesHost_56 = this._ɵDomSharedStylesHost_53); }
    return this.__ɵSharedStylesHost_56;
  }
  get _Testability_57():import0.Testability {
    if ((this.__Testability_57 == null)) { (this.__Testability_57 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_57;
  }
  get _Meta_58():import4.Meta {
    if ((this.__Meta_58 == null)) { (this.__Meta_58 = new import4.Meta(this.parent.get(import4.DOCUMENT))); }
    return this.__Meta_58;
  }
  get _Title_59():import4.Title {
    if ((this.__Title_59 == null)) { (this.__Title_59 = new import4.Title(this.parent.get(import4.DOCUMENT))); }
    return this.__Title_59;
  }
  get _BrowserXhr_60():import5.BrowserXhr {
    if ((this.__BrowserXhr_60 == null)) { (this.__BrowserXhr_60 = new import5.BrowserXhr()); }
    return this.__BrowserXhr_60;
  }
  get _ResponseOptions_61():import5.BaseResponseOptions {
    if ((this.__ResponseOptions_61 == null)) { (this.__ResponseOptions_61 = new import5.BaseResponseOptions()); }
    return this.__ResponseOptions_61;
  }
  get _XSRFStrategy_62():any {
    if ((this.__XSRFStrategy_62 == null)) { (this.__XSRFStrategy_62 = import5.ɵb()); }
    return this.__XSRFStrategy_62;
  }
  get _XHRBackend_63():import5.XHRBackend {
    if ((this.__XHRBackend_63 == null)) { (this.__XHRBackend_63 = new import5.XHRBackend(this._BrowserXhr_60,this._ResponseOptions_61,this._XSRFStrategy_62)); }
    return this.__XHRBackend_63;
  }
  get _RequestOptions_64():import5.BaseRequestOptions {
    if ((this.__RequestOptions_64 == null)) { (this.__RequestOptions_64 = new import5.BaseRequestOptions()); }
    return this.__RequestOptions_64;
  }
  get _Http_65():any {
    if ((this.__Http_65 == null)) { (this.__Http_65 = import5.ɵc(this._XHRBackend_63,this._RequestOptions_64)); }
    return this.__Http_65;
  }
  get _FormBuilder_66():import6.FormBuilder {
    if ((this.__FormBuilder_66 == null)) { (this.__FormBuilder_66 = new import6.FormBuilder()); }
    return this.__FormBuilder_66;
  }
  get _ɵi_67():import6.ɵi {
    if ((this.__ɵi_67 == null)) { (this.__ɵi_67 = new import6.ɵi()); }
    return this.__ɵi_67;
  }
  get _PositionResolver_68():import8.PositionResolver {
    if ((this.__PositionResolver_68 == null)) { (this.__PositionResolver_68 = new import8.PositionResolver()); }
    return this.__PositionResolver_68;
  }
  get _ScrollRegister_69():import8.ScrollRegister {
    if ((this.__ScrollRegister_69 == null)) { (this.__ScrollRegister_69 = new import8.ScrollRegister()); }
    return this.__ScrollRegister_69;
  }
  get _NguCarouselService_70():import24.NguCarouselService {
    if ((this.__NguCarouselService_70 == null)) { (this.__NguCarouselService_70 = new import24.NguCarouselService()); }
    return this.__NguCarouselService_70;
  }
  get _BREAKPOINTS_71():any {
    if ((this.__BREAKPOINTS_71 == null)) { (this.__BREAKPOINTS_71 = import47.DEFAULT_BREAKPOINTS_PROVIDER_FACTORY()); }
    return this.__BREAKPOINTS_71;
  }
  get _BreakPointRegistry_72():import25.BreakPointRegistry {
    if ((this.__BreakPointRegistry_72 == null)) { (this.__BreakPointRegistry_72 = new import25.BreakPointRegistry(this._BREAKPOINTS_71)); }
    return this.__BreakPointRegistry_72;
  }
  get _MatchMedia_73():import26.MatchMedia {
    if ((this.__MatchMedia_73 == null)) { (this.__MatchMedia_73 = new import26.MatchMedia(this.parent.get(import0.NgZone))); }
    return this.__MatchMedia_73;
  }
  get _MediaMonitor_74():any {
    if ((this.__MediaMonitor_74 == null)) { (this.__MediaMonitor_74 = import48.MEDIA_MONITOR_PROVIDER_FACTORY(this.parent.get(import49.MediaMonitor,(null as any)),this._BreakPointRegistry_72,this._MatchMedia_73)); }
    return this.__MediaMonitor_74;
  }
  get _ObservableMedia_75():any {
    if ((this.__ObservableMedia_75 == null)) { (this.__ObservableMedia_75 = import50.OBSERVABLE_MEDIA_PROVIDER_FACTORY(this.parent.get(import51.ObservableMedia,(null as any)),this._MatchMedia_73,this._BreakPointRegistry_72)); }
    return this.__ObservableMedia_75;
  }
  get _PositioningService_76():import27.PositioningService {
    if ((this.__PositioningService_76 == null)) { (this.__PositioningService_76 = new import27.PositioningService()); }
    return this.__PositioningService_76;
  }
  get _ComponentLoaderFactory_77():import28.ComponentLoaderFactory {
    if ((this.__ComponentLoaderFactory_77 == null)) { (this.__ComponentLoaderFactory_77 = new import28.ComponentLoaderFactory(this.componentFactoryResolver,this.parent.get(import0.NgZone),this,this._PositioningService_76,this._ApplicationRef_7)); }
    return this.__ComponentLoaderFactory_77;
  }
  get _BsDropdownState_78():import29.BsDropdownState {
    if ((this.__BsDropdownState_78 == null)) { (this.__BsDropdownState_78 = new import29.BsDropdownState()); }
    return this.__BsDropdownState_78;
  }
  get _BsModalService_80():import30.BsModalService {
    if ((this.__BsModalService_80 == null)) { (this.__BsModalService_80 = new import30.BsModalService(this._ComponentLoaderFactory_77)); }
    return this.__BsModalService_80;
  }
  get _TooltipConfig_81():import31.TooltipConfig {
    if ((this.__TooltipConfig_81 == null)) { (this.__TooltipConfig_81 = new import31.TooltipConfig()); }
    return this.__TooltipConfig_81;
  }
  get _ConfirmationPopoverOptions_83():any {
    if ((this.__ConfirmationPopoverOptions_83 == null)) { (this.__ConfirmationPopoverOptions_83 = import14.optionsFactory(this._USER_OPTIONS_82)); }
    return this.__ConfirmationPopoverOptions_83;
  }
  get _Positioning_84():import32.Positioning {
    if ((this.__Positioning_84 == null)) { (this.__Positioning_84 = new import32.Positioning()); }
    return this.__Positioning_84;
  }
  get _TabsetConfig_85():import33.TabsetConfig {
    if ((this.__TabsetConfig_85 == null)) { (this.__TabsetConfig_85 = new import33.TabsetConfig()); }
    return this.__TabsetConfig_85;
  }
  get _AccordionConfig_86():import34.AccordionConfig {
    if ((this.__AccordionConfig_86 == null)) { (this.__AccordionConfig_86 = new import34.AccordionConfig()); }
    return this.__AccordionConfig_86;
  }
  get _ActivatedRoute_87():any {
    if ((this.__ActivatedRoute_87 == null)) { (this.__ActivatedRoute_87 = import3.ɵf(this._Router_39)); }
    return this.__ActivatedRoute_87;
  }
  get _NoPreloading_88():import3.NoPreloading {
    if ((this.__NoPreloading_88 == null)) { (this.__NoPreloading_88 = new import3.NoPreloading()); }
    return this.__NoPreloading_88;
  }
  get _PreloadingStrategy_89():any {
    if ((this.__PreloadingStrategy_89 == null)) { (this.__PreloadingStrategy_89 = this._NoPreloading_88); }
    return this.__PreloadingStrategy_89;
  }
  get _RouterPreloader_90():import3.RouterPreloader {
    if ((this.__RouterPreloader_90 == null)) { (this.__RouterPreloader_90 = new import3.RouterPreloader(this._Router_39,this._NgModuleFactoryLoader_37,this._Compiler_36,this,this._PreloadingStrategy_89)); }
    return this.__RouterPreloader_90;
  }
  get _PreloadAllModules_91():import3.PreloadAllModules {
    if ((this.__PreloadAllModules_91 == null)) { (this.__PreloadAllModules_91 = new import3.PreloadAllModules()); }
    return this.__PreloadAllModules_91;
  }
  get _ROUTER_INITIALIZER_92():any {
    if ((this.__ROUTER_INITIALIZER_92 == null)) { (this.__ROUTER_INITIALIZER_92 = import3.ɵi(this._ɵg_3)); }
    return this.__ROUTER_INITIALIZER_92;
  }
  get _APP_BOOTSTRAP_LISTENER_93():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_93 == null)) { (this.__APP_BOOTSTRAP_LISTENER_93 = [this._ROUTER_INITIALIZER_92]); }
    return this.__APP_BOOTSTRAP_LISTENER_93;
  }
  get _CLIENT_MAP_95():any {
    if ((this.__CLIENT_MAP_95 == null)) { (this.__CLIENT_MAP_95 = import52.getClientMap(this._CLIENT_MAP_WRAPPER_94)); }
    return this.__CLIENT_MAP_95;
  }
  get _Apollo_96():any {
    if ((this.__Apollo_96 == null)) { (this.__Apollo_96 = import52.createApollo(this._CLIENT_MAP_95)); }
    return this.__Apollo_96;
  }
  get _UserService_97():import35.UserService {
    if ((this.__UserService_97 == null)) { (this.__UserService_97 = new import35.UserService(this._Apollo_96,this._Http_65)); }
    return this.__UserService_97;
  }
  get _WindowRefService_98():import36.WindowRefService {
    if ((this.__WindowRefService_98 == null)) { (this.__WindowRefService_98 = new import36.WindowRefService()); }
    return this.__WindowRefService_98;
  }
  get _AuthService_99():import37.AuthService {
    if ((this.__AuthService_99 == null)) { (this.__AuthService_99 = new import37.AuthService(this._Http_65,this._Router_39,this._Apollo_96,this._WindowRefService_98)); }
    return this.__AuthService_99;
  }
  get _AuthGuard_100():import38.AuthGuard {
    if ((this.__AuthGuard_100 == null)) { (this.__AuthGuard_100 = new import38.AuthGuard(this._AuthService_99)); }
    return this.__AuthGuard_100;
  }
  get _ArtistSearchService_101():import39.ArtistSearchService {
    if ((this.__ArtistSearchService_101 == null)) { (this.__ArtistSearchService_101 = new import39.ArtistSearchService(this._Apollo_96)); }
    return this.__ArtistSearchService_101;
  }
  createInternal():import1.AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ErrorHandler_1 = import4.ɵa();
    this._NgProbeToken_2 = [import3.ɵb()];
    this._ɵg_3 = new import3.ɵg(this);
    this._APP_INITIALIZER_4 = [
      import0.ɵo,
      import4.ɵc(this.parent.get(import4.NgProbeToken,(null as any)),this._NgProbeToken_2),
      import3.ɵh(this._ɵg_3)
    ]
    ;
    this._ApplicationInitStatus_5 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_4);
    this._ɵf_6 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_1,this.componentFactoryResolver,this._ApplicationInitStatus_5);
    this._ApplicationRef_7 = this._ɵf_6;
    this._ApplicationModule_8 = new import0.ApplicationModule(this._ApplicationRef_7);
    this._BrowserModule_9 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._HttpModule_10 = new import5.HttpModule();
    this._ɵba_11 = new import6.ɵba();
    this._ReactiveFormsModule_12 = new import6.ReactiveFormsModule();
    this._FormsModule_13 = new import6.FormsModule();
    this._SharedcoreModule_14 = new import7.SharedcoreModule();
    this._InfiniteScrollModule_15 = new import8.InfiniteScrollModule();
    this._BsDropdownModule_16 = new import9.BsDropdownModule();
    this._NguCarouselModule_17 = new import10.NguCarouselModule();
    this._ButtonsModule_18 = new import11.ButtonsModule();
    this._ModalModule_19 = new import12.ModalModule();
    this._TooltipModule_20 = new import13.TooltipModule();
    this._ConfirmationPopoverModule_21 = new import14.ConfirmationPopoverModule();
    this._TabsModule_22 = new import15.TabsModule();
    this._CollapseModule_23 = new import16.CollapseModule();
    this._AccordionModule_24 = new import17.AccordionModule();
    this._TypeaheadModule_25 = new import18.TypeaheadModule();
    this._SwiperModule_26 = new import19.SwiperModule(this.parent.get(import19.SWIPER_GUARD,(null as any)));
    this._MediaQueriesModule_27 = new import20.MediaQueriesModule();
    this._FlexLayoutModule_28 = new import21.FlexLayoutModule();
    this._SharedModule_29 = new import22.SharedModule();
    this._ɵa_30 = import3.ɵd(this.parent.get(import3.Router,(null as any)));
    this._UrlSerializer_31 = new import3.DefaultUrlSerializer();
    this._RouterOutletMap_32 = new import3.RouterOutletMap();
    this._ROUTER_CONFIGURATION_33 = {};
    this._LocationStrategy_34 = import3.ɵc(this.parent.get(import2.PlatformLocation),this.parent.get(import2.APP_BASE_HREF,(null as any)),this._ROUTER_CONFIGURATION_33);
    this._Location_35 = new import2.Location(this._LocationStrategy_34);
    this._Compiler_36 = new import0.Compiler();
    this._NgModuleFactoryLoader_37 = new import0.SystemJsNgModuleLoader(this._Compiler_36,this.parent.get(import0.SystemJsNgModuleLoaderConfig,(null as any)));
      this._ROUTES_38 = [[
        {
          path: 'list',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./users/user-internal/user-internal.module.ngfactory')['UserListModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'external',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./users/user-external/user-external.module.ngfactory')['UserExternalModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'requests',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./users/new-user-request/new-user-request.module.ngfactory')['NewUserRequestModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'settings',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./users/user-settings/user-settings.module.ngfactory')['UserSettingsModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'help',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./help/help.module.ngfactory')['HelpModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'restrictions',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./users/app-restrictions/app-restrictions.module.ngfactory')['AppRestrictionsModuleNgFactory']);  });}),
          canActivate: [import38.AuthGuard]
        }
        ,
        {
          path: 'auth/okta',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./auth/okta/authentication.module.ngfactory')['OktaAuthenticationModuleNgFactory']);  });})
        }
        ,
        {
          path: 'auth/activation',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./auth/activation/activation.module.ngfactory')['ActivationModuleNgFactory']);  });})
        }
        ,
        {
          path: 'auth/password-reset',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./auth/activation/activation.module.ngfactory')['ActivationModuleNgFactory']);  });})
        }
        ,
        {
          path: 'user/detect',
          loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./auth/user-detection/user-detection.module.ngfactory')['UserDetectionModuleNgFactory']);  });})
        }

      ]
    ];
    this._Router_39 = import3.ɵe(this._ApplicationRef_7,this._UrlSerializer_31,this._RouterOutletMap_32,this._Location_35,this,this._NgModuleFactoryLoader_37,this._Compiler_36,this._ROUTES_38,this._ROUTER_CONFIGURATION_33,this.parent.get(import3.UrlHandlingStrategy,(null as any)),this.parent.get(import3.RouteReuseStrategy,(null as any)));
    this._RouterModule_40 = new import3.RouterModule(this._ɵa_30,this._Router_39);
    this._ApolloModule_41 = new import23.ApolloModule();
    this._AppModule_42 = new import1.AppModule(this._ApplicationRef_7);
    this._BsDropdownConfig_79 = {autoClose: true};
    this._USER_OPTIONS_82 = {};
    this._CLIENT_MAP_WRAPPER_94 = import53.provideClients;
    return this._AppModule_42;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_1; }
    if ((token === import0.NgProbeToken)) { return this._NgProbeToken_2; }
    if ((token === import3.ɵg)) { return this._ɵg_3; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_4; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_5; }
    if ((token === import0.ɵf)) { return this._ɵf_6; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_7; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_8; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_9; }
    if ((token === import5.HttpModule)) { return this._HttpModule_10; }
    if ((token === import6.ɵba)) { return this._ɵba_11; }
    if ((token === import6.ReactiveFormsModule)) { return this._ReactiveFormsModule_12; }
    if ((token === import6.FormsModule)) { return this._FormsModule_13; }
    if ((token === import7.SharedcoreModule)) { return this._SharedcoreModule_14; }
    if ((token === import8.InfiniteScrollModule)) { return this._InfiniteScrollModule_15; }
    if ((token === import9.BsDropdownModule)) { return this._BsDropdownModule_16; }
    if ((token === import10.NguCarouselModule)) { return this._NguCarouselModule_17; }
    if ((token === import11.ButtonsModule)) { return this._ButtonsModule_18; }
    if ((token === import12.ModalModule)) { return this._ModalModule_19; }
    if ((token === import13.TooltipModule)) { return this._TooltipModule_20; }
    if ((token === import14.ConfirmationPopoverModule)) { return this._ConfirmationPopoverModule_21; }
    if ((token === import15.TabsModule)) { return this._TabsModule_22; }
    if ((token === import16.CollapseModule)) { return this._CollapseModule_23; }
    if ((token === import17.AccordionModule)) { return this._AccordionModule_24; }
    if ((token === import18.TypeaheadModule)) { return this._TypeaheadModule_25; }
    if ((token === import19.SwiperModule)) { return this._SwiperModule_26; }
    if ((token === import20.MediaQueriesModule)) { return this._MediaQueriesModule_27; }
    if ((token === import21.FlexLayoutModule)) { return this._FlexLayoutModule_28; }
    if ((token === import22.SharedModule)) { return this._SharedModule_29; }
    if ((token === import3.ɵa)) { return this._ɵa_30; }
    if ((token === import3.UrlSerializer)) { return this._UrlSerializer_31; }
    if ((token === import3.RouterOutletMap)) { return this._RouterOutletMap_32; }
    if ((token === import3.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_33; }
    if ((token === import2.LocationStrategy)) { return this._LocationStrategy_34; }
    if ((token === import2.Location)) { return this._Location_35; }
    if ((token === import0.Compiler)) { return this._Compiler_36; }
    if ((token === import0.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_37; }
    if ((token === import3.ROUTES)) { return this._ROUTES_38; }
    if ((token === import3.Router)) { return this._Router_39; }
    if ((token === import3.RouterModule)) { return this._RouterModule_40; }
    if ((token === import23.ApolloModule)) { return this._ApolloModule_41; }
    if ((token === import1.AppModule)) { return this._AppModule_42; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_43; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_44; }
    if ((token === import0.APP_ID)) { return this._APP_ID_45; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_46; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_47; }
    if ((token === import4.DomSanitizer)) { return this._DomSanitizer_48; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_49; }
    if ((token === import4.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_50; }
    if ((token === import4.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_51; }
    if ((token === import4.EventManager)) { return this._EventManager_52; }
    if ((token === import4.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_53; }
    if ((token === import4.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_54; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_55; }
    if ((token === import4.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_56; }
    if ((token === import0.Testability)) { return this._Testability_57; }
    if ((token === import4.Meta)) { return this._Meta_58; }
    if ((token === import4.Title)) { return this._Title_59; }
    if ((token === import5.BrowserXhr)) { return this._BrowserXhr_60; }
    if ((token === import5.ResponseOptions)) { return this._ResponseOptions_61; }
    if ((token === import5.XSRFStrategy)) { return this._XSRFStrategy_62; }
    if ((token === import5.XHRBackend)) { return this._XHRBackend_63; }
    if ((token === import5.RequestOptions)) { return this._RequestOptions_64; }
    if ((token === import5.Http)) { return this._Http_65; }
    if ((token === import6.FormBuilder)) { return this._FormBuilder_66; }
    if ((token === import6.ɵi)) { return this._ɵi_67; }
    if ((token === import8.PositionResolver)) { return this._PositionResolver_68; }
    if ((token === import8.ScrollRegister)) { return this._ScrollRegister_69; }
    if ((token === import24.NguCarouselService)) { return this._NguCarouselService_70; }
    if ((token === import54.BREAKPOINTS)) { return this._BREAKPOINTS_71; }
    if ((token === import25.BreakPointRegistry)) { return this._BreakPointRegistry_72; }
    if ((token === import26.MatchMedia)) { return this._MatchMedia_73; }
    if ((token === import49.MediaMonitor)) { return this._MediaMonitor_74; }
    if ((token === import51.ObservableMedia)) { return this._ObservableMedia_75; }
    if ((token === import27.PositioningService)) { return this._PositioningService_76; }
    if ((token === import28.ComponentLoaderFactory)) { return this._ComponentLoaderFactory_77; }
    if ((token === import29.BsDropdownState)) { return this._BsDropdownState_78; }
    if ((token === import55.BsDropdownConfig)) { return this._BsDropdownConfig_79; }
    if ((token === import30.BsModalService)) { return this._BsModalService_80; }
    if ((token === import31.TooltipConfig)) { return this._TooltipConfig_81; }
    if ((token === import14.USER_OPTIONS)) { return this._USER_OPTIONS_82; }
    if ((token === import56.ConfirmationPopoverOptions)) { return this._ConfirmationPopoverOptions_83; }
    if ((token === import32.Positioning)) { return this._Positioning_84; }
    if ((token === import33.TabsetConfig)) { return this._TabsetConfig_85; }
    if ((token === import34.AccordionConfig)) { return this._AccordionConfig_86; }
    if ((token === import3.ActivatedRoute)) { return this._ActivatedRoute_87; }
    if ((token === import3.NoPreloading)) { return this._NoPreloading_88; }
    if ((token === import3.PreloadingStrategy)) { return this._PreloadingStrategy_89; }
    if ((token === import3.RouterPreloader)) { return this._RouterPreloader_90; }
    if ((token === import3.PreloadAllModules)) { return this._PreloadAllModules_91; }
    if ((token === import3.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_92; }
    if ((token === import0.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_93; }
    if ((token === import57.CLIENT_MAP_WRAPPER)) { return this._CLIENT_MAP_WRAPPER_94; }
    if ((token === import57.CLIENT_MAP)) { return this._CLIENT_MAP_95; }
    if ((token === import52.Apollo)) { return this._Apollo_96; }
    if ((token === import35.UserService)) { return this._UserService_97; }
    if ((token === import36.WindowRefService)) { return this._WindowRefService_98; }
    if ((token === import37.AuthService)) { return this._AuthService_99; }
    if ((token === import38.AuthGuard)) { return this._AuthGuard_100; }
    if ((token === import39.ArtistSearchService)) { return this._ArtistSearchService_101; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_6.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_53 && this._ɵDomSharedStylesHost_53.ngOnDestroy());
    (this.__RouterPreloader_90 && this._RouterPreloader_90.ngOnDestroy());
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory<any>(AppModuleInjector,import1.AppModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/app.module.ngfactory.ts